import React, { useEffect, useState } from "react";
import { FEED_WORLD_SITE_URL } from "../apis/ssoApi";

// The organisation's name and tagline, set on the website in Admin → Website → Header & footer
// (GET /api/v1/website/brand): changing it there changes it here, in the website and in the mobile app.
// The last name seen is kept in this browser, so pages show it at once (and when the website can't be reached).
// "FEED World" is the monthly magazine (a service), a different thing.
export const DEFAULT_BRAND = { name: "FEED M S C S LTD", tagline: "Empowering Farmers, Enriching Futures" };

const STORAGE_KEY = "brand";
const listeners = new Set();

const readSaved = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    return saved?.name ? { ...DEFAULT_BRAND, ...saved } : DEFAULT_BRAND;
  } catch (e) {
    return DEFAULT_BRAND;
  }
};

let current = readSaved();
let loading = null;

/** The name right now (outside React, e.g. messages built in api helpers). */
export const brandName = () => current.name;

/** Asks the website once per page load; listeners update when the name changed. */
export const loadBrand = () => {
  if (!loading) {
    loading = fetch(`${FEED_WORLD_SITE_URL}/api/v1/website/brand`, { headers: { Accept: "application/json" } })
      .then((res) => (res.ok ? res.json() : null))
      .then((body) => {
        const data = body?.data;
        if (!data?.name) return;
        current = { name: data.name, tagline: data.tagline || DEFAULT_BRAND.tagline };
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
        } catch (e) {
          // private window: keep it for this page only
        }
        document.title = current.name;
        listeners.forEach((update) => update(current));
      })
      .catch(() => {});
  }
  return loading;
};

/** { name, tagline } for a component; re-renders when the website's name arrives. */
export const useBrand = () => {
  const [brand, setBrand] = useState(current);
  useEffect(() => {
    listeners.add(setBrand);
    loadBrand();
    return () => listeners.delete(setBrand);
  }, []);
  return brand;
};

document.title = current.name;

/** The name as text, in any JSX: <BrandName /> */
export const BrandName = () => useBrand().name;

/** Two-tone title (login / register): the first word, then the rest in the accent <span>. */
export const BrandTitle = () => {
  const [first, ...rest] = useBrand().name.split(" ");
  return (
    <>
      {first} <span>{rest.join(" ")}</span>
    </>
  );
};
